import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3","key":"svg-0"}],["path",{"d":"M7 10a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1l0 -8","key":"svg-1"}],["path",{"d":"M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0","key":"svg-2"}]]

const IconCash = createReactComponent('outline', 'cash', 'Cash', __iconNode);

export default IconCash;